import { Controller, useFormContext } from 'react-hook-form';
import { Lock01 } from '@untitledui/icons';
import { Input } from '@/components/base/input/input';
import { AUTH_FORM_SIZE } from '@/shared/config/auth-form';
import type { SignupFormValues } from '../schema';

export const Step03Senha = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<SignupFormValues>();

  return (
    <Controller
      control={control}
      name="senha"
      render={({ field }) => (
        <Input
          label="Senha"
          type="password"
          size={AUTH_FORM_SIZE}
          icon={Lock01}
          placeholder="••••••••"
          autoComplete="new-password"
          autoFocus
          isInvalid={!!errors.senha}
          hint={
            errors.senha?.message ??
            'Mínimo 8 caracteres, 1 maiúscula, 1 número e 1 caractere especial.'
          }
          value={field.value ?? ''}
          onChange={field.onChange}
          onBlur={field.onBlur}
          name={field.name}
        />
      )}
    />
  );
};
